import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, MapPinIcon, ArrowRightIcon, ClockIcon, TrendingUpIcon, BarChartIcon } from 'lucide-react';
const PropertyCard = ({
  property
}) => {
  // Determine badge color based on investment strategy
  const getStrategyBadgeColor = strategy => {
    switch (strategy) {
      case 'Long-Term Hold':
        return 'bg-blue-100 text-blue-800';
      case 'Short-Term Flip':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  // Determine if property is a flip or hold
  const isFlip = property.investmentStrategy === 'Short-Term Flip';
  return <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow" data-id="element-53">
      <div className="relative" data-id="element-54">
        <img src={property.imageUrl} alt={property.name} className="w-full h-48 object-cover" data-id="element-55" />
        <div className="absolute top-3 right-3" data-id="element-56">
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStrategyBadgeColor(property.investmentStrategy)}`} data-id="element-57">
            {property.investmentStrategy}
          </span>
        </div>
      </div>
      <div className="p-4" data-id="element-58">
        <h3 className="text-lg font-medium text-gray-900 mb-1" data-id="element-59">
          {property.name}
        </h3>
        <div className="flex items-center text-gray-500 text-sm mb-2" data-id="element-60">
          <MapPinIcon className="w-4 h-4 mr-1" data-id="element-61" />
          <span className="truncate" data-id="element-62">{property.address}</span>
        </div>
        <div className="grid grid-cols-2 gap-2 mb-4" data-id="element-63">
          <div data-id="element-64">
            <p className="text-xs text-gray-500" data-id="element-65">Type</p>
            <p className="font-medium text-sm" data-id="element-66">{property.type}</p>
          </div>
          <div data-id="element-67">
            <p className="text-xs text-gray-500" data-id="element-68">Size</p>
            <p className="font-medium text-sm" data-id="element-69">
              {property.size.toLocaleString()} sq ft
            </p>
          </div>
          <div data-id="element-70">
            <p className="text-xs text-gray-500" data-id="element-71">Value</p>
            <p className="font-medium text-sm" data-id="element-72">
              ${property.value.toLocaleString()}
            </p>
          </div>
          <div data-id="element-73">
            <p className="text-xs text-gray-500" data-id="element-74">
              {isFlip ? '% Complete' : 'Occupancy'}
            </p>
            <p className="font-medium text-sm" data-id="element-75">{property.occupancy}%</p>
          </div>
        </div>
        {/* Investment strategy metrics */}
        <div className="border-t border-gray-200 pt-3 mb-3" data-id="element-76">
          <div className="flex items-center mb-2" data-id="element-77">
            <ClockIcon className="w-4 h-4 text-gray-500 mr-1" data-id="element-78" />
            <span className="text-sm text-gray-700" data-id="element-79">
              {property.expectedHoldPeriod}
            </span>
          </div>
          {property.investmentStrategy === 'Long-Term Hold' ? <div className="flex items-center" data-id="element-80">
              <BarChartIcon className="w-4 h-4 text-gray-500 mr-1" data-id="element-81" />
              <span className="text-sm text-gray-700" data-id="element-82">
                Cap Rate: {property.capRate}%
              </span>
            </div> : <div className="flex items-center" data-id="element-83">
              <TrendingUpIcon className="w-4 h-4 text-gray-500 mr-1" data-id="element-84" />
              <span className="text-sm text-gray-700" data-id="element-85">
                Projected ROI: {property.projectedROI}%
              </span>
            </div>}
        </div>
        <Link to={`/properties/${property.id}`} className="flex items-center justify-center w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-86">
          View Details
          <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-87" />
        </Link>
      </div>
    </div>;
};
export default PropertyCard;